import useMutationSubcontractorImportReimport from "./subcontractor-use-mutation-import-reimport";


export const subcontractorUseMutation = {
  importReimport: useMutationSubcontractorImportReimport,
}